// 전직 규칙. 바꾸는·막는 대운 전환기에 방향이 맞는 전직 기회가 열린다. 운은 스탯을 바꾸지 않고 기회만 연다.
// 전환기 길이·나이 범위·단계 인정은 게임 수치이며 고서의 근거가 아니다.
import { luckAt } from './luckPhase.js';
import { classifyTransition } from './luckTransition.js';
import { directionFor } from './arcDirection.js';
import { essenceFor } from './events.js';

export const JOB_CHANGE_RULES = Object.freeze({
  minAge: 30,          // 전직 기회가 열리는 나이 범위
  maxAge: 55,          // 은퇴(60세) 5년 전까지
  maxOffers: 3,
  openOn: Object.freeze(['바꾸는', '막는']), // 이 전환 유형일 때 열린다. 막는 전환기는 손실 사건이 나오는 시기와 같아 일이 맞지 않으면 바꿀 기회가 함께 온다
});

/** 이전 직업의 단계를 한 단계 낮춰 인정한다. 최소 1, 최대 3 (4단계 갈래는 새 직업에서 다시 얻는다). */
export const levelAfterChange = (level) => Math.max(1, Math.min(3, (level ?? 1) - 1));

/**
 * 지금 전직 기회가 열려 있는지 본다. 열려 있으면 { luck, direction }, 아니면 null.
 * 새 규칙(luckModel: 'environment')의 진행만 해당한다. 같은 대운에서 이미 제안을 받았으면(수락·거절 모두) 열리지 않는다.
 */
export function changeWindow(s) {
  if (s.luckModel !== 'environment' || s.status !== 'play' || !s.job) return null;
  if (s.age < JOB_CHANGE_RULES.minAge || s.age > JOB_CHANGE_RULES.maxAge) return null;
  if (s.job.since === s.age) return null;
  const luck = luckAt(s.saju, s.age);
  if (!luck.inTransition || s.jobChangeUsedFor === luck.startAge) return null;
  const essence = essenceFor(s.saju);
  const type = essence ? classifyTransition(essence, luck) : null;
  if (!type || !JOB_CHANGE_RULES.openOn.includes(type)) return null;
  const direction = directionFor(essence, s.age);
  return direction ? { luck, direction } : null;
}
